import { Button, Input, TextArea, Typography } from '@recruit-robin/robin-theme/web-components';
import { Edit_03 } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useProcessCampaignAIMutation } from 'shared/legacy/hooks/useProcessCampaignAIMutation';
import { useCampaignStore } from 'stores/campaign/campaign.store';
import { useCreateEnrichedVacancy } from '../../../../hooks/useCreateEnrichedVacancy';
import { EnrichVacancyModalContext } from '../../../EnrichVacancyModalContext/EnrichVacancyModalContext';
import { EnrichVacancyModalType } from '../../../EnrichVacancyModalContext/EnrichVacancyModalContext.types';
import { LoadingPage } from '../../../LoadingPage/LoadingPage';
import { useStyles } from './CreateFromJobDescription.styles';

export const CreateFromJobDescription = ({ goBackButton }: { goBackButton: React.ReactNode }) => {
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const modalType = useContextSelector(EnrichVacancyModalContext, (s) => s.modalType);
  const selectedCampaignId = useCampaignStore((s) => s.campaign?.id);
  const { handleCreateFromJobDescription } = useCreateEnrichedVacancy();

  const {
    mutateAsync: processCampaignAI,
    isLoading: isProcessingCampaignAI,
    data,
    isError: isErrorProcessingCampaignAI,
  } = useProcessCampaignAIMutation();

  useEffect(() => {
    if (modalType === EnrichVacancyModalType.Indeed) {
      return;
    }
    if (isErrorProcessingCampaignAI) return;
    if (isProcessingCampaignAI) return;
    if (data || data === null) return;

    if (selectedCampaignId) {
      processCampaignAI(selectedCampaignId.toString()).then((vacancyText) => {
        setDescription(vacancyText ?? '');
      });
    }
  }, [selectedCampaignId, isProcessingCampaignAI, modalType, data, isErrorProcessingCampaignAI]);

  const handleSubmit = async () => {
    if (!description.trim()) return;

    handleCreateFromJobDescription({ subject: subject.trim(), description: description.trim() });
  };

  if (isProcessingCampaignAI) {
    return (
      <div css={classes.root}>
        <LoadingPage message={`${dictionary.loading}...`} />
      </div>
    );
  }

  return (
    <div css={classes.root}>
      <div css={classes.header}>
        <Typography variant={(v) => v.heading[4]} color={(c) => c.neutral.variant[70]}>
          <span css={classes.icon}>
            <Edit_03 />
          </span>
          {dictionary.jobDescription}
        </Typography>
      </div>
      <div css={classes.textAreaWrapper}>
        <div css={[classes.suggestionBox, classes.suggestionBoxEditing]}>
          {modalType === EnrichVacancyModalType.Indeed && (
            <Input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder={dictionary.jobTitle}
              contained
            />
          )}
          <TextArea
            css={classes.textArea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={dictionary.pasteJobDescription}
            disableResize
          />
        </div>
      </div>
      <div css={classes.saveButtonWrapper}>
        {goBackButton}

        <Button
          style="filled"
          type="default"
          onClick={handleSubmit}
          disabled={!description.trim() || (modalType === EnrichVacancyModalType.Indeed && !subject.trim())}
          label={dictionary.processJob}
        />
      </div>
    </div>
  );
};
